export function secondsToTime(seconds) {
    let hours = Math.floor(seconds / 3600);
    seconds = seconds % 3600;

    let mins = Math.floor(seconds / 60);
    seconds = seconds % 60;

    let time_string = '';

    if (hours > 0) time_string += `${hours}:`;

    if (hours > 0 && mins < 10) {
        time_string += '0';
    }

    time_string += `${mins}:${seconds < 10 ? '0' : ''}${seconds}`;

    return time_string;
}

export function currentTimestamp() {
    return Math.floor(new Date().getTime() / 1000);
}